import React, { forwardRef } from 'react';
import cn from 'classnames';
import { PaginationNumberedProps } from '../types';

import { CuiOptionType } from '../../helpers/types';
import IconButton from '../../Buttons/IconButton';
import Dropdown from '../../Dropdown';

const Default = forwardRef<HTMLDivElement, PaginationNumberedProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      onPageChange,
      dark,
      white,
      displayPosition = 'responsive',
      className,
      ...other
    },
    ref,
  ) => {
    const onSelected = (selected?: CuiOptionType<number>) => {
      if (typeof onPageChange === 'function') {
        onPageChange(selected?.value || 1);
      }
    };

    const labelClassNames = cn(
      'font-body3 text-nowrap',
      dark ? 'text-base-lighter' : 'text-gray-dark',
    );

    return (
      <div
        ref={ref}
        className={cn(
          'w-full sm:w-auto flex items-center justify-center sm:justify-start',
          className,
        )}
        {...other}
      >
        <IconButton
          arrow="left"
          darkMode={dark}
          white={white}
          disabled={currentPage <= 1}
          onClick={onPrev}
        />
        <p className={cn(labelClassNames, 'ml-8 mr-8 sm:ml-32 sm:mr-24')}>
          <span className="sm:hidden">Pág</span>
          <span className="hidden sm:inline">Página</span>
        </p>
        <Dropdown
          className="w-72 sm:w-80"
          options={Array.from({ length: totalPages }).map((_, i) => ({
            value: i + 1,
            label: (i + 1).toString(),
          }))}
          onSelected={onSelected}
          selected={{ value: currentPage, label: currentPage.toString() }}
          required
          dark={dark}
          displayPosition={displayPosition}
          clampText={false}
        />
        <span className={cn(labelClassNames, 'ml-8 mr-8 sm:ml-24 sm:mr-32')}>
          {`de ${totalPages}`}
        </span>
        <IconButton
          arrow="right"
          darkMode={dark}
          white={white}
          disabled={currentPage >= totalPages}
          onClick={onNext}
        />
      </div>
    );
  },
);

export default Default;
